import { render, staticRenderFns } from "./sys_role.vue?vue&type=template&id=f107bbc4&scoped=true"
import script from "./sys_role.vue?vue&type=script&lang=js"
export * from "./sys_role.vue?vue&type=script&lang=js"
import style0 from "./sys_role.vue?vue&type=style&index=0&id=f107bbc4&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f107bbc4",
  null
  
)

export default component.exports